var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-public"},[_c('div',{staticClass:"layout-public__main d-flex flex-column"},[_c('LayoutPublicHeader'),_c('div',{staticClass:"layout-public__main-section d-flex flex-column justify-content-center flex-grow-1 py-5"},[_vm._t("default")],2)],1),_c('LayoutPublicFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }